// src/components/TicketCard.tsx

import React from "react";
import "./ticket_card.css";
import dayjs from "dayjs";
import { t } from "../../../services/locale.service";

// The Ticket interface predefines all potential ticket parameters, allowing flexibility for future use.
interface Ticket {
  id: number;
  title: string;
  plotid: string;
  customername: string;
  farmermobile: string;
  cropid: string;
  created_at: string;
  updated_at: string;
  priority_id: number;
  article_count: number;
  article_ids: number[];
  state_id: number;
}

interface TicketCardProps {
    ticket: Ticket;
    // onClick: () => void; 
  }

// const TicketCard: React.FC<TicketCardProps> = ({ ticket, onClick }) => {
const TicketCard: React.FC<TicketCardProps> = ({ ticket }) => {
  return (
    // <div className="ticket-card" onClick={onClick}>
    <div className="ticket-card" >
      <div className="ticket-card__left">
        <div className="ticket-card__title">{ticket.title ?? t("No_Title")}</div>
        <div className="ticket-card__updated-date">
          {t("Updated")} {dayjs(ticket.updated_at).format("DD/MM/YYYY hh:mm A")}
        </div>
      </div>
      <div className="ticket-card__right">
        {ticket.state_id === 2 && <span className="ticket-card__state-dot"></span>}
      </div>
    </div>
  );
};

export default TicketCard;
 
